module.exports = __webpack_public_path__ + "img/6-1.21acedf2.png";